<div class="block-of-help-cards">
    <app-slide [withArrows]="false" (draggingEvent)="receiveEvent($event)" [margin]="23" [elementWidth]="372" [elementQty]="helpCenterModel.length">
        <ng-container *ngIf="helpCenterModel.length !== 0">
            <app-help-card [notRedirect]="notRedirect" *ngFor="let item of helpCenterModel" [dataCardHelp]="item">
            </app-help-card>
        </ng-container>
    </app-slide>
</div>
